import api from '../api';
import { ApiSuccessResponse } from '../types';
import { QdeliveryApi, QdeliveryWallet } from './types';

export type GetImpersonationRes = ApiSuccessResponse<QdeliveryApi> & {
  session_id: string;
};

const getImpersonation = async () => {
  return api.post<GetImpersonationRes>('/qdelivery/impersonation');
};
const getQdeliveryWallet = async () => {
  const response = await api.get<
    ApiSuccessResponse<{ data: QdeliveryWallet[] }>
  >('/qdelivery/wallets');
  const { currency_unit, amount, amount_int } = response.data.data[0];
  return { currency_unit, amount, amount_int };
};
export default {
  getImpersonation,
  getQdeliveryWallet,
};
